import { getApps, initializeApp } from "firebase/app";
import { browserLocalPersistence, getAuth, setPersistence, type Auth } from "firebase/auth";

const firebaseConfig = {
  // Firebase web configuration identifies the public client; authorization is
  // still enforced by Firebase rules and signed ID tokens at the API boundary.
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "valuer-mashr-ai.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "valuer-mashr-ai",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:98262267194:web:fefb80e04102ed20aacc03"
};

export const firebaseConfigured = Boolean(firebaseConfig.apiKey && firebaseConfig.projectId && firebaseConfig.appId);

export const auth: Auth | null = firebaseConfigured
  ? getAuth(getApps()[0] ?? initializeApp(firebaseConfig))
  : null;

export const authReady = auth
  ? setPersistence(auth, browserLocalPersistence).catch(() => undefined)
  : Promise.resolve();
